import {useFormik} from "formik";
import * as Yup from "yup";
import {persianToEnglish} from "../../tools/helpers";
import React, {useContext, useEffect, useState} from "react";
import Button from "../Button";
import Api from "../../tools/service";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import ProgressLoading from "../loading/ProgressLoading";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import DatePicker from "../DatePicker";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import Switch from "react-switch";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const InitConfirm = () => {
    const serviceContext = useContext(AuthenticationServiceContext);
    const [checkSwitch, setCheckSwitch] = useState(false)
    const [loading, setLoading] = useState(false);
    const handleSubmit = (values) => {


        let data = {
            pid: serviceContext.pid,
        }
        if (values?.businessLicenseType && values.businessLicenseType !== "default") {
            data.business_type=values.businessLicenseType;

            if(values?.SecParameter&&values.SecParameter.length>0){
                data.business_type.params[0].value=persianToEnglish(values.SecParameter);
            }
        }
        if(serviceContext.process?.init_confirm_inputs.includes('NationalId') && serviceContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY){
            data.NationalId=persianToEnglish(values.NationalId);
        }
        if(serviceContext.process?.init_confirm_inputs.includes('BirthDate')){
            data.BirthDate=values.BirthDate;
        }

        setLoading(true);
        Api.put(REQUEST_URLS.AUTHENTICATION.INIT_CONFIRM, data, {
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then((response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                setLoading(false)
                serviceContext.handleError({
                    status,
                    message,
                    data,
                    pid: serviceContext.pid,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                            },
                            confirmButtonText: '',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'بستن',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                serviceContext.handleGetProcess(serviceContext.pid);
            }
        })).catch(e => {

        })

    }
    const [selectedBusinessType, setSelectedBusinessType] = useState(serviceContext.process?.selected_business_type ? serviceContext.process?.selected_business_type:null);
    const formik = useFormik({
        initialValues: {
            ...(serviceContext.process?.init_confirm_inputs.includes('NationalId') && serviceContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY && {
                NationalId: serviceContext.process?.national_id || ''
            }),
            ...(serviceContext.process?.init_confirm_inputs.includes('BirthDate') && {
                BirthDate: ''
            }),



        },

        validationSchema:()=>{
            return buildValidationSchema(serviceContext.process?.init_confirm_inputs, selectedBusinessType);
        },
        onSubmit: handleSubmit,
    });
    const defaultInputs = {
        NationalId: {
            label: 'کد ملی',
            placeholder: 'کد ملی را وارد کنید'
        },
        BirthDate: {
            label: 'تاریخ تولد',
            placeholder: 'تاریخ تولد را وارد کنید'
        }
    }
    const buildValidationSchema = (validationFields, businessServiceType) => {
        let schema = Yup.object();

        if (validationFields.includes('NationalId') && serviceContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY) {
            schema = schema.shape({
                NationalId: Yup.string()
                    .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
                    .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
                    .required('کد ملی را وارد کنید.')
                    .test("isNumber", "کد ملی عددی می باشد", (value) => {
                        if (!value) {
                            return false;
                        }
                        return !isNaN(persianToEnglish(value));
                    }),
            });
        }

        if (validationFields.includes('BirthDate')) {
            schema = schema.shape({
                BirthDate: Yup.string().required('تاریخ تولد را وارد کنید.'),
            });
        }

        if (businessServiceType?.params) {
            const additionalFields = businessServiceType.params.reduce((acc, item) => {
                acc[item.en] = Yup.string().required(`${item.fa} را وارد کنید`).test("isNumber", item.fa+" عددی می باشد", (value) => {
                    if (!value) {
                        return false;
                    }
                    return !isNaN(persianToEnglish(value));
                });
                return acc;
            }, {});

            schema = schema.shape(additionalFields);
        }

        // Add other fields to the schema similarly if needed

        return schema;
    };
    const handleSelectBusinessType = (e) => {

        const selected = serviceContext.process?.available_business_types.find((type) => type.en === e.target.value);

        if (selected) {
            setSelectedBusinessType(selected)
            formik.setFieldValue('businessLicenseType', selected);
            formik.setFieldValue('SecParameter','');
        } else {
            setSelectedBusinessType(null)
            formik.setFieldValue('businessLicenseType', 'default')
            formik.setFieldValue('SecParameter',null);
        }

    }
    useEffect(() => {
        if (serviceContext.process?.selected_business_type) {
            setSelectedBusinessType(serviceContext.process?.selected_business_type);

            formik.setFieldValue('businessLicenseType', serviceContext.process?.selected_business_type);
            if(serviceContext.process?.selected_business_type.params){
                formik.setFieldValue('SecParameter', serviceContext.process?.selected_business_type.params[0].value)
            }

        }
    }, [])
    if (loading) {
        return <ProgressLoading showProgress={false} type="NIDCardReader" duration={30} text="در حال دریافت اطلاعات "
                                theme="green"/>
    }

    return <div className="flex  flex-col items-center  justify-center">
        <div className="w-11/12 lg:w-4/12 mx-auto bg-white mt-2   p-5 rounded-lg ">
            <div className="border-b flex flex-col items-center  my-1 pb-2 ">
                <h1 className="mb-1 font-bold text-lg ">تکمیل اطلاعات </h1>
            </div>
            <label className="text-sm mb-3 "
            >تلفن همراه</label>
            <input disabled
                   className="w-full mt-1    bg-green-900 opacity-50  text-white  text-right text-sm rounded-xl p-3"
                   type="tel"
                   id="mobile"
                   name="mobile"
                   placeholder="تلفن همراه"
                   value={serviceContext.process.platform_user}
            />
            <form onSubmit={formik.handleSubmit}>
                {serviceContext.process?.init_confirm_inputs.map((fieldName) => (
                    <div className="flex flex-col mt-2" key={fieldName}>

                        {fieldName === 'NationalId' && serviceContext.process?.reseted_step !== AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY && serviceContext.process?.reseted_step !== AuthenticationDefaultSteps.AUTO_NID_CARD && (
                            <>
                                <label className="text-sm mb-1 "
                                       htmlFor={fieldName}>{defaultInputs[fieldName].label}</label>
                                <input className="w-full   bg-gray-100  text-right rounded-xl p-3 text-sm"
                                       type="tel"
                                       id={fieldName}
                                       name={fieldName}
                                       placeholder={defaultInputs[fieldName].placeholder}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                       value={formik.values[fieldName]}
                                />
                            </>
                        )}

                        {fieldName === 'BirthDate' && (
                            <>
                                <label className="text-sm mb-2 mt-1 "
                                       htmlFor={fieldName}>{defaultInputs[fieldName].label}</label>
                                <DatePicker onError={value => formik.setFieldValue('BirthDate', value)}
                                            initialDate={serviceContext.process.birth_date} onComplete={(value) => {
                                    formik.setFieldValue('BirthDate', value)
                                }}/>
                            </>


                        )}

                        {formik.touched[fieldName] && formik.errors[fieldName] && (
                            <p className="text-red-400 text-sm font-light mt-1">{formik.errors[fieldName]}</p>
                        )}
                    </div>
                ))}
                {serviceContext.process?.available_business_types && serviceContext.process?.selected_service_types?.includes('BusinessLicenseInquiry') &&
                    <div className="my-2">
                        <label className="text-sm mt-2" htmlFor="">
                            نوع پروانه کسب
                        </label>
                        {
                            serviceContext.process?.available_business_types && <select
                                defaultValue={serviceContext.process?.selected_business_type ? serviceContext.process?.selected_business_type.en : 'default'}
                                name="" onChange={handleSelectBusinessType}
                                className="w-full bg-gray-100 text-sm border-gray-200 border outline-0  py-2 rounded-lg px-3"
                                id="">
                                <option className="text-sm" value="default"> نوع پروانه کسب و کار را انتخاب کنید</option>
                                {serviceContext.process?.available_business_types.map((type) => {
                                    return <option key={type.en} className="text-sm" value={type.en}>{type.fa}</option>
                                })}
                            </select>
                        }
                        {selectedBusinessType && selectedBusinessType.params && <div>
                            {selectedBusinessType.params.map((item, index) => {
                                return <div className="mt-3" key={selectedBusinessType.en + index + 'sec'}>
                                    <label className="text-sm" htmlFor="">{item.fa}</label>
                                    <input  className="w-full   bg-gray-100  text-right rounded-xl p-3 text-sm"
                                           type="tel"
                                           id={item.en}
                                           name={item.en}
                                           defaultValue={item.value}
                                           placeholder={item.fa + ' را وارد کنید'}
                                           onChange={formik.handleChange}
                                           onBlur={formik.handleBlur}/>

                                    {formik.touched[item.en] && formik.errors[item.en] && (
                                        <p className="text-red-400 text-sm font-light mt-1">{formik.errors[item.en]}</p>
                                    )}
                                </div>
                            })}
                            {}
                        </div>}
                    </div>}
                <div className="flex justify-between my-10 ">
                    <label className="text-sm pl-2" htmlFor="insurance">از صحت تطابق شماره موبایل، کد ملی و تاریخ تولد
                        اطمینان دارم.</label>
                    <Switch onColor="#36b570" onChange={(checked) => {
                        setCheckSwitch(checked)

                    }} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                            checked={checkSwitch}/>
                </div>

                <Button disabled={!checkSwitch} className="text-sm mt-3 w-full rounded-lg " theme="green"
                        type={"submit"}>ادامه</Button>
            </form>
        </div>
    </div>
}

export default InitConfirm;